import { useUser } from 'components/providers/UserProvider'
import pricingSettingsWelcome from 'img/pricing-settings-welcome.png'
import { useTranslation } from 'react-i18next'

export const PricingSettingsWelcome = (): JSX.Element => {
  const { t } = useTranslation()
  const { user } = useUser()

  // Same order as the tabs in PricingSettings.
  const steps = [
    {
      title: t('pricingSettings.welcomeStep1Title'),
      description: t('pricingSettings.welcomeStep1Description'),
    },
    {
      title: t('pricingSettings.welcomeStep2Title'),
      description: t('pricingSettings.welcomeStep2Description'),
    },
    {
      title: t('pricingSettings.welcomeStep3Title'),
      description: t('pricingSettings.welcomeStep3Description'),
    },
    ...(user?.featureFlags?.taxation
      ? [
          {
            title: t('pricingSettings.welcomeStep4Title'),
            description: t('pricingSettings.welcomeStep4Description'),
          },
        ]
      : []),
    {
      title: t('pricingSettings.welcomeStep5Title'),
      description: t('pricingSettings.welcomeStep5Description'),
    },
  ]

  return (
    <div className="pricing-settings-welcome">
      <div className="pricing-settings-welcome__content">
        <h3>{t('pricingSettings.welcomeTitle')}</h3>
        <p className="mb-4">{t('pricingSettings.welcomeIntro', { count: steps.length })}</p>
        <ol className="pricing-settings-welcome__steps">
          {steps.map(({ title, description }, idx) => (
            <li key={idx}>
              <h6 className="m-0">{title}</h6>
              <p className="m-0">{description}</p>
            </li>
          ))}
        </ol>
      </div>
      <div className="pricing-settings-welcome__image">
        <img src={pricingSettingsWelcome} alt="" />
      </div>
    </div>
  )
}
